import React from "react";
import Select from 'react-select';
import { COLORS } from '../../utils/colors'

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    width: 250,
    zIndex: 2
  }),

  dropdownIndicator: () => ({
  }),
}

const getOptionValue = (option) => {
  return option && option.value ? option.value.title : '';
}

const getOptionLabel = (option) => {
  let availableColor = option.value;
  return ( availableColor && 
  <div className="d-flex align-items-center">
    <div style={{ backgroundColor: availableColor.hex, minWidth: '15px', height: '15px', border: '1px solid', display: 'inline-block', marginRight: '4px'}} />
    <div>{availableColor.title}</div>
    <div><em className="small text-muted">{availableColor.RAL} {availableColor.HKS}</em></div>
  </div>);
}

const ColorSelect = props => {
  const { input, defaultStyles, materialSerie } = props;
  return (
    <Select 
      {...input} 
      onChange={value => input.onChange(value)} 
      onBlur={event => event.preventDefault()}
      options={COLORS[materialSerie].map((availableColor) => {
        return ({ value: availableColor, label: availableColor.title});
      })
      }
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      styles={defaultStyles ? {} : customStyles}
      isSearchable={true}
    />
  )
}

export default ColorSelect;